import { render, staticRenderFns } from "./AgreementsPage.vue?vue&type=template&id=77ccf56f&"
import script from "./AgreementsPage.vue?vue&type=script&lang=js&"
export * from "./AgreementsPage.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports